import { render, staticRenderFns } from "./ElectricityHistogram.vue?vue&type=template&id=e227aebc&scoped=true&"
import script from "./ElectricityHistogram.vue?vue&type=script&lang=js&"
export * from "./ElectricityHistogram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e227aebc",
  null
  
)

export default component.exports